<template>
    <div>
        <bita-breadcrumb :items="breadCrumbs" />
            <div class="wrapper wrapper-content animated fadeInRight">
                <bita-ibox :is-loading="isLoadingPage">
                    <div slot="body">
                        <bita-grid
                            ref="grid"
                            :columns="gridColumns"
                            :read-data="readData"
                            :page-size="pageSize"
                            :current-page="currentPage"
                            :has-row-number="true"
                        />
                    </div>
                </bita-ibox>
            </div>
        <ticketing-form ref="ticketingForm" :title="title" @load-data="loadData" />
    </div>
</template>
<script>
import { ticketApi } from "@/api/apiManagement";
import ticketingForm from "./components/TicketingForm.vue";

export default {
    components: {
        ticketingForm
    },
    data() {
        return {
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                {
                title: "مدیریت تیکتینگ",
                link: "/ticketings/tickets",
                active: true,
                },
            ],
            isLoadingPage: false,
            pageSize: 10,
            currentPage: 1,
            title: "",
        }
    },
    computed: {
        gridColumns() {
            return [
                { title: "عنوان", template: e => (e.title ? e.title : '-') },
                { title: "ایجاد کننده", template: e => ( e.user_id && e.user && e.user.full_name ? e.user.full_name : '-' ) },
                { title: "وضعیت", template: e => ( e.status && e.status_text ? e.status_text : '-' ) },
                { title: "زمان ایجاد", template: e => (e.created_at ? this.$getJalaliDateTime(e.created_at) : '-') },
                { title: "آخرین به روز رسانی", template: e => ( e.updated_at ? this.$getJalaliDateTime(e.updated_at) : '-' ) },
                { title: "عملیات", command: this.gridCommands() }
            ]
        }
    },
    methods: {
        readData(e) {
            this.isLoadingPage = true;
            ticketApi.gets()
                .then( (res) => {
                    e.success(res.data.entity);
                })
                .catch( () => e.success([]) )
                .finally( () => this.isLoadingPage = false );
        },
        loadData() {
            this.$refs.grid.loadDataSource();
        },
        gridCommands() {
            let commands = [];
            commands.push({
                text: "edit",
                click: this.edit,
                template: this.gridButtons.edit
            });
            commands.push({
                text: "delete",
                click: this.delete,
                template: this.gridButtons.delete
            });
            return commands;
        },
        edit(e) {
            let ticketing = this.$refs.grid.getSelectedGridRow(e);
            this.title = `ویرایش ${ticketing.title} `;
            this.$refs.ticketingForm.setInitialData(ticketing);
            this.$toggleModal("#ticketing-form");
        },
        delete(e) {
            let ticketing = this.$refs.grid.getSelectedGridRow(e);
            this.$alert(
                "question",
                `آیا از حذف درخواست شماره ${ticketing.title} اطمینان دارید ؟`,
                "",
                {
                confirmButtonText: "بله",
                }
            ).then((result) => {
                if (result.value) {
                this.isLoadingPage = true;
                ticketApi.delete(ticketing.id)
                    .then((res) => {
                        this.$izitoast("success", "موفق!", res.data.message);
                        this.loadData();
                    })
                    .finally(() => this.isLoadingPage = false )
                }
            });
        },
    }
}
</script>